import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";

const EmployeeFormModal = ({
  open,
  onClose,
  onSave,
  formData,
  storeLocations,
  handleChange,
  handlePermissionChange,
  isEditMode,
  isSubmitting,
  errors,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isEditMode ? "Edit Employee" : "Add New Employee"}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="First Name"
              value={formData.firstName}
              onChange={(e) => handleChange("firstName", e.target.value)}
              fullWidth
              required
              error={!!errors.firstName}
              helperText={errors.firstName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Last Name"
              value={formData.lastName}
              onChange={(e) => handleChange("lastName", e.target.value)}
              fullWidth
              required
              error={!!errors.lastName}
              helperText={errors.lastName}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Employee ID"
              value={formData.employeeID}
              onChange={(e) => handleChange("employeeID", e.target.value)}
              fullWidth
              required
              error={!!errors.employeeID}
              helperText={errors.employeeID}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="POS Passcode"
              type="password"
              value={formData.posPasscode}
              onChange={(e) => handleChange("posPasscode", e.target.value)}
              fullWidth
              required={!isEditMode}
              error={!!errors.posPasscode}
              helperText={
                errors.posPasscode ||
                (isEditMode && "Leave blank to keep current passcode")
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Work Location"
              value={formData.workLocation}
              onChange={(e) => handleChange("workLocation", e.target.value)}
              select
              fullWidth
              required
              error={!!errors.workLocation}
              helperText={errors.workLocation}>
              {storeLocations.map((loc) => (
                <MenuItem key={loc._id} value={loc._id}>
                  {loc.displayName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Role"
              value={formData.role}
              onChange={(e) => handleChange("role", e.target.value)}
              select
              fullWidth>
              {["staff", "admin", "manager", "supervisor"].map((role) => (
                <MenuItem key={role} value={role}>
                  {role.charAt(0).toUpperCase() + role.slice(1)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Email"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Phone"
              value={formData.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Permissions:
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canUpdateOrders}
                  onChange={(e) =>
                    handlePermissionChange("canUpdateOrders", e.target.checked)
                  }
                />
              }
              label="Can Update Orders"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canIssueRefunds}
                  onChange={(e) =>
                    handlePermissionChange("canIssueRefunds", e.target.checked)
                  }
                />
              }
              label="Can Issue Refunds"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canAdjustPoints}
                  onChange={(e) =>
                    handlePermissionChange("canAdjustPoints", e.target.checked)
                  }
                />
              }
              label="Can Adjust Points"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canEditProducts}
                  onChange={(e) =>
                    handlePermissionChange("canEditProducts", e.target.checked)
                  }
                />
              }
              label="Can Edit Products"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSave} disabled={isSubmitting}>
          {isEditMode ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmployeeFormModal;
